export default __webpack_public_path__ + "static/media/07-3.ad4d7439.jpg";